import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import DesktopSidebar from '../navigation/DesktopSidebar';
import MobileTabBar from '../navigation/MobileTabBar';
import { useInnNotification } from '../../hooks/useInnNotification';
interface LayoutProps {
    children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
    // Автоматически показываем модалку при загрузке, если нужно
    useInnNotification(true);

    return (
        <Flex h="100%" minH={0} bg="gray.100" overflow="hidden" direction="column">
            {/* Основной контент */}
            <Flex flex={1} minH={0} overflow="hidden" bg="gray.100">
                {/* Десктопная боковая панель */}
                <Box display={{ base: 'none', lg: 'block' }}>
                    <DesktopSidebar />
                </Box>

                {/* Основной контент */}
                <Box
                    flex={1}
                    minH={0}
                    p={{ base: 0, lg: 6 }}
                    overflow="hidden"
                    display="flex"
                    flexDirection="column"
                    alignItems={{ base: 'stretch', md: 'center' }}
                    bg="gray.100"
                    ml={{ base: 0, lg: '280px' }}
                    boxShadow={{ base: 'none', lg: '0 4px 20px rgba(0, 0, 0, 0.05)' }}
                >
                    {children}
                </Box>
            </Flex>

            {/* Мобильная нижняя навигация */}
            <Box display={{ base: 'block', lg: 'none' }}>
                <MobileTabBar />
            </Box>
        </Flex>
    );
};

export default Layout;
